import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconOpenInNewComponent } from "./med-icon-open-in-new.component";

@NgModule({
  declarations: [
    MedIconOpenInNewComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconOpenInNewComponent,
  ],
})
export class MedIconOpenInNewModule { }
